import styled from 'styled-components';
import { theme } from '@jadwalh/ui';
export const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  justify-content: center;
  height: 100vh;
  .img-container {
    display: flex;
    margin-bottom: 15px;
    width: 100%;
    justify-content: center;
    svg {
      @media (max-width: 1024px) {
        height: unset !important;
        width:100%;
      }
    }
  }
  label {
    font-size: 24px;
    font-weight: 600;
    line-height: 24px;
  }
  span {
    color: #856404;
    font-size: 14px;
  }
  button {
    background-color: ${theme.colours.blackText};
    color: white;
    border-radius: 12px;
    font-size: 14px;
    padding: 7px 25px;
    border: none;
    line-height: 22px;
    cursor: pointer;
  }
`;
